var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 122.88 116.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.53 91.55 13.23 13.23c3.2.09 5.77 2.72 5.77 5.95 0 3.29-2.66 5.95-5.95 5.95s-5.95-2.67-5.95-5.95c0-.36.03-.72.09-1.07l-11.51-11.5v8.46h-8.24v-8.23l-11.69 11.7c.02.21.03.43.03.65 0 3.29-2.66 5.95-5.96 5.95-3.29 0-5.95-2.67-5.95-5.95 0-3.29 2.67-5.95 5.95-5.95.1 0 .2 0 .29.01l13.23-13.23L0 91.55V7.52c0-.87.72-1.57 1.61-1.57h55.36V0h8.24v5.95h56.06c.89 0 1.61.71 1.61 1.57v84.02H69.53zM26.89 62.71l23.26-22.74c5.76 5.76 11.46 11.46 17.28 17.21l15.41-15.6-7.15-7.15 20.12-.18v20.29l-6.87-6.87c-7.16 7.25-14.29 14.48-21.47 21.67L50.03 52.12 32.99 68.81zm86.9-40.98H8.92v60.64h104.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArrowUp);
export default __webpack_public_path__ + "static/media/chart-arrow-up.b8726ba5760427d618a36943ad537551.svg";
export { ForwardRef as ReactComponent };